import {createApp, nextTick} from 'vue';
import axios from 'axios';
import Datepicker from 'vue3-datepicker';
import Snotify from 'vue3-snotify';
import Cookies from 'js-cookie';
import {Carousel, Slide, Navigation, Pagination} from 'vue3-carousel';
import PriceFormatter from '../PriceFormatter';
import DateFormatter from '../DateFormatter';
import ScrollPage from '../ScrollPage';
import AddressList from '../components/address-list/address-list';
import ctaCard from '../components/cta-card';
import comparisonPriceTable from '../../comparison-price-table';

ctaCard();

const priceCalculator = async () => {
    const el = document.querySelector('.sf-price-calculator');

    if (el) {
        const app = createApp({
            delimiters: ['${', '}'],
            components: {
                Datepicker,
                AddressList,
                Carousel,
                Slide,
                Navigation,
                Pagination
            },
            data() {
                return {
                    /*
                    // MC: the closest available video is now selected via method.  If new videos are added, list them there.
                    videos: {
                      10: '/video/10_sqft.mp4',
                      15: '/video/15_sqft.mp4',
                      20: '/video/25_sqft.mp4',
                      25: '/video/25_sqft.mp4',
                      30: '/video/30_sqft.mp4',
                      35: '/video/35_sqft.mp4',
                      40: '/video/35_sqft.mp4',
                      45: '/video/50_sqft.mp4',
                      50: '/video/50_sqft.mp4',
                      60: '/video/60_sqft.mp4',
                      65: '/video/65_sqft.mp4',
                      70: '/video/65_sqft.mp4',
                      75: '/video/75_sqft.mp4',
                      100: '/video/100_sqft.mp4',
                      110: '/video/110_sqft.mp4',
                      120: '/video/120_sqft.mp4',
                      125: '/video/120_sqft.mp4',
                      135: '/video/120_sqft.mp4',
                      150: '/video/150_sqft.mp4',
                      165: '/video/165_sqft.mp4',
                      175: '/video/165_sqft.mp4',
                      190: '/video/190_sqft.mp4',
                      200: '/video/205_sqft.mp4',
                      205: '/video/205_sqft.mp4',
                      215: '/video/215_sqft.mp4',
                      235: '/video/235_sqft.mp4',
                      250: '/video/250_sqft.mp4',
                      270: '/video/270_sqft.mp4',
                      290: '/video/290_sqft.mp4',
                      300: '/video/290_sqft.mp4',
                      475: '/video/475_sqft.mp4',
                    },
                    */
                    carouselBreakpoints: {
                        0: {
                            itemsToShow: 1,
                            snapAlign: 'center',
                            wrapAround: true,
                        },
                        800: {
                            itemsToShow: 3,
                            snapAlign: 'center',
                            wrapAround: true,
                        }
                    },
                    carousel: null,
                    form: {
                        id: null,
                        selectedLocation: null,
                        firstName: null,
                        lastName: null,
                        email: null,
                        emailChanged: 0,
                        phone: null,
                        postcode: null,
                        selectedTitle: 'Mr',
                        agreement: false,
                        duration: 1,
                        unitIndex: 0,
                        moveInDate: DateFormatter(new Date(Date.now() + (24 * 60 * 60 * 1000))),
                        pickUp: 'No',
                        addressLine1: null,
                        addressLine2: null,
                        addressLine3: null,
                        cityTown: null,
                        county: null,
                        country: null,
                        quote: 'Upper floor',
                        reserveOrEmail: 'Reserve',
                        selectedFloor: null,
                        fullPrice: 0,
                        discountedPrice: 0
                    },
                    sharedComputer: false,
                    selectedUnit: null,
                    formErrors: {},
                    locationList: [],
                    titleOptions: [
                        {value: 'Mr'},
                        {value: 'Mrs'},
                        {value: 'Miss'},
                        {value: 'Ms'}
                    ],
                    stores: [],
                    isMobile: window.innerWidth < 800,
                    sizeOptions: {
                        dotSize: 24,
                        formatter: '{value}',
                        height: 4,
                        min: 0,
                        max: 1,
                        interval: 1,
                        speed: 0.1,
                        piecewise: true
                    },
                    durationOptions: [
                        {
                            id: 1,
                            value: 'Up to <br/> 3 months'
                        },
                        {
                            id: 2,
                            value: '3-6 <br/>  months'
                        },
                        {
                            id: 3,
                            value: 'Over <br/> 6 months'
                        },
                        {
                            id: 4,
                            value: 'Don’t <br/> know'
                        }
                    ],
                    moveIn: {
                        date: new Date(Date.now() + (24 * 60 * 60 * 1000)),
                    },
                    discount: {
                        percentage: 0,
                        duration: 12
                    },
                    complete: false,
                    steps: {
                        1: {
                            label: 'Register',
                            state: 'loading',
                            lock_on_comp: true,
                        },
                        2: {
                            label: 'Calculate',
                            state: 'loading',
                            lock_on_comp: false,
                        },
                        3: {
                            label: 'Confirm',
                            state: 'init',
                            lock_on_comp: false,
                        }
                    },
                    currentStep: 1,
                    addressList: [],
                    showAddressFields: false,
                    step1Email: null,
                    skippingStep1: false,
                    comparisonHtml: null,
                    showComparisonTable: false,
                };
            },
            mounted() {
                this.fetchSites();
                window.addEventListener('resize', this.handleResize);
            },
            beforeUnmount() {
                window.removeEventListener('resize', this.handleResize);
            },
            methods: {
                handleResize() {
                    this.isMobile = window.innerWidth < 800;
                },
                onSubmit() {
                    if (this.steps[3].state === 'loading') {
                        return;
                    }

                    this.formErrors = {};

                    this.updateStepState(['3'], 'loading');

                    this.reserve();
                },
                completeStep1() {
                    const endpoint = '/actions/storefirst/quote/store-customer-record';
                    const params = this.getCsrfAwareParams(this.form);

                    this.updateStepState(['1'], 'loading');

                    return axios.post(endpoint, params).then((response) => {
                      this.form.id = response.data.customer.id;
                      this.step1Email = this.form.email;
                      this.updateStepState(['1'], 'complete');
                      this.gotoStep(2);
                      this.reportConversion();

                      if(response.data.crypt && !this.sharedComputer) {
                        Cookies.set('previous_quote', response.data.crypt, { expires: 5 });
                      }

                      nextTick(() => {
                        ScrollPage('step2');
                      })
                    }).catch((error) => {
                      this.updateStepState(['1'], 'complete');
                      this.handleValidationErrors(error);
                    });
                },
                completeStep2(floor, type) {
                    this.form.reserveOrEmail = type;

                    switch (floor) {
                        case 'external':
                            this.form.quote = 'External';
                            this.form.selectedFloor = this.selectedUnit.ex[0];
                            break;
                        case 'upper':
                            this.form.quote = 'Upper floor';
                            this.form.selectedFloor = this.selectedUnit.uf[0];
                            break;
                        default:
                            this.form.quote = 'Ground floor';
                            this.form.selectedFloor = this.selectedUnit.gf[0];
                    }

                    this.updateStepState(['2'], 'complete')
                    this.gotoStep(3);

                    nextTick(() => {
                        ScrollPage('step3');
                    })
                },
                reserve() {
                    const endpoint = '/actions/storefirst/quote/handle-submission';

                    this.setPrices(this.form.selectedFloor);

                    if (this.step1Email != this.form.email) {
                        this.form.emailChanged = 1;
                    }

                    return axios.post(endpoint, this.getCsrfAwareParams(this.form))
                        .then(response => {
                            this.complete = true;
                            this.updateStepState(['3'], 'complete');
                            nextTick(() => {
                                ScrollPage('lastStep');
                            });
                        })
                        .catch((error) => {
                            this.showAddressFields = true;
                            this.handleValidationErrors(error);
                        });
                },
                getAddressList() {
                    const {postcode} = this.form;

                    if (postcode == null || postcode.length < 3) {
                        this.formErrors.postcode = ['Please enter a valid postcode'];
                        return;
                    }

                    delete this.formErrors.postcode;

                    this.$refs.addressListComponent.reload(postcode);
                },
                toggleAddressFields() {
                    this.showAddressFields = !this.showAddressFields;
                },
                updateAddress(address) {
                    this.form.addressLine1 = address.address_line_1;
                    this.form.addressLine2 = address.address_line_2;
                    this.form.cityTown = address.city;
                    this.form.county = address.county;
                    this.form.postcode = address.postcode;
                },
                handleValidationErrors(error) {
                    this.updateStepState(['3'], 'ready');

                    this.$snotify.error('Invalid details provided. Please browse up and fix the fields marked with an error');

                    this.formErrors = error.response.data.error;
                },
                gotoStep(theStep) {
                    const prev = theStep - 1;

                    const stepID = parseInt(theStep);
                    const target = this.steps[stepID];

                    if ((target.state == 'complete' && target.lock_on_comp == true) ||
                        (typeof this.steps[prev] !== 'undefined' && this.steps[prev].state !== 'complete')) {
                        return;
                    }

                    this.complete = false;
                    this.currentStep = stepID;

                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0;
                },
                backToCalculator() {
                    this.gotoStep(2);
                    ScrollPage('step2');
                },
                fetchSites() {
                    const urlParams = new URLSearchParams(window.location.search);
                    const previousQuote = this.getPreviousQuote(urlParams);
                    const params = this.getCsrfAwareParams();
                    const promises = [];

                    promises.push(axios.post('/actions/storefirst/quote/site-list', params));

                    if (previousQuote) {
                        params.append('previous_quote', previousQuote);
                        promises.push(axios.post('/actions/storefirst/quote/get-previous-quote', params));
                    }

                    axios.all(promises).then(response => {
                        this.handleSiteListResponse(response, urlParams);
                        this.handlePreviousQuoteResponse(response);

                        if (!this.skippingStep1) {
                            this.updateStepState(['1', '2'], 'ready');
                        }
                    }).catch((error) => {
                        this.$snotify.error(
                            'Please refresh the page to try again. If the problem persists, please contact support',
                            'Error'
                        );
                    });
                },
                handleSiteListResponse(response, urlParams) {
                    const locationParam = urlParams.get('location');

                    this.locationList = response[0].data;
                    const defaultSelection = this.locationList[0];
                    let location;

                    if (!locationParam) {
                        this.form.selectedLocation = defaultSelection;
                        location = defaultSelection;
                    } else {
                        location = this.findLocationByName(locationParam);
                    }

                    this.form.selectedLocation = location;

                    this.moveInDate = DateFormatter(this.moveIn.date);
                },
                handlePreviousQuoteResponse(response) {
                    if (typeof response[1] === 'undefined') {
                        return;
                    }

                    if (typeof response[1].data.error !== 'undefined') {
                        this.$snotify.error(
                            'We encountered a problem while retrieving your quote. Please contact support.',
                            'Sorry'
                        );
                        return;
                    }

                    const {data} = response[1];

                    this.form.id = data.customer_id;
                    this.form.selectedTitle = data.customer_title;
                    this.form.firstName = data.customer_first_name;
                    this.form.lastName = data.customer_surname;
                    this.form.phone = data.customer_phone_number;
                    this.form.email = data.customer_email;
                    this.form.agreement = true;

                    if (typeof data.reservation_site.SiteID !== 'undefined') {
                        this.form.selectedLocation = this.findLocation(data.reservation_site.SiteID);
                    }

                    this.skippingStep1 = true;
                },
                handleUnitSizesResponse(response) {
                    const sizes = response.data.availableSizes;

                    this.stores = [];

                    sizes.forEach((s) => {
                        s.contents_protection = parseFloat(s.contents_protection);
                        s.preview = `https://www.storefirst.com/static/images/size_examples/${s.size}_sq_ft.jpg`;

                        this.stores.push(s);
                    });

                    this.sizeOptions.max = sizes.length > 0 ? sizes.length - 1 : 1;

                    const defaultIndex = sizes.length > 0 ? Math.floor(sizes.length / 2) : 0;

                    nextTick(() => {
                        this.swapUnit(defaultIndex);
                        if (this.$refs.carousel) {
                            this.$refs.carousel.slideTo(defaultIndex);
                        }
                    });
                },
                handleDiscountResponse(response) {
                    const data = response.data[0];

                    this.discount.percentage = parseInt(data.Discount);
                    this.discount.duration = parseInt(data.InvoicePeriod);
                },
                getCsrfAwareParams(additional = {}) {
                    const params = new URLSearchParams();

                    params.append(window.csrfTokenName, window.csrfTokenValue);

                    Object.entries(additional)
                        .forEach((p) => {
                            const key = p[0];
                            const val = p[1];

                            if (typeof val === 'object' && val != null) {
                                params.append(key, JSON.stringify(val));
                            } else {
                                params.append(key, val || '');
                            }
                        });

                    return params;
                },
                findLocationByName(name) {
                    return this.locationList.find((l) => l.Sitename.toLowerCase() == name.toLowerCase());
                },
                findLocation(id) {
                    return this.locationList.find((l) => l.SiteID == id);
                },
                formatPrice(price, discount = 0) {
                    return PriceFormatter(price, {
                        'discount_percentage': discount,
                        'contents_protection': this.selectedUnit.contents_protection
                    });
                },
                getError(fieldName) {
                    if (typeof this.formErrors[fieldName] !== 'undefined') {
                        return this.formErrors[fieldName][0];
                    }

                    return null;
                },
                limitedAvailability(floor) {
                    let selector;

                    switch (floor) {
                        case 'ground':
                            selector = 'gf';
                            break;
                        case 'upper':
                            selector = 'uf';
                            break;
                        default:
                            selector = 'ex';
                    }

                    if (this.selectedUnit[selector] && this.selectedUnit[selector][0] && this.selectedUnit[selector][0].size <= 25) {
                        return true;
                    }

                    if (!this.selectedUnit[selector] || this.selectedUnit[selector].length === 0) {
                        return false;
                    }

                    return this.selectedUnit[selector][0].limitedAvailability;
                },
                showReserveButton(selectedUnit, floor) {
                    let unitFloor;

                    switch (floor) {
                        case 'ground':
                            unitFloor = 'gf';
                            break;
                        case 'upper':
                            unitFloor = 'uf';
                            break;
                        default:
                            unitFloor = 'ex';
                    }

                    if (unitFloor.size <= 25 && this.limitedAvailability(floor) === true) {
                        return false;
                    }

                    if (this.form.selectedLocation.limitedUnits != '1') {
                        return true;
                    }

                    return this.form.selectedLocation.limitedUnits == '1' && this.limitedAvailability(floor) === false;
                },
                getSelectedFloor() {
                    const unit = this.selectedUnit;
                    let floor;

                    console.log(unit)

                    if ('uf' in unit && Array.isArray(unit.uf) && unit.uf.length > 0) {
                        floor = unit.uf[0];
                    } else if ('ex' in unit && Array.isArray(unit.ex) && unit.ex.length > 0) {
                        floor = unit.ex[0];
                    } else if ('gf' in unit && Array.isArray(unit.gf) && unit.gf.length > 0) {
                        floor = unit.gf[0];
                    } else {
                        console.error('Something went wrong');
                    }

                    if (!floor) {
                        return null;
                    }

                    return floor;
                },
                swapUnit(val) {
                    const index = parseInt(val);
                    this.selectedUnit = this.stores[index];
                    this.form.unitIndex = index;
                },
                updateStepState(steps, state) {
                    steps.forEach((s) => this.steps[s].state = state);
                },
                setPrices(unit) {
                    if (!unit || !unit.weekRate) {
                        return;
                    }

                    this.form.fullPrice = this.formatPrice(unit.weekRate)
                    this.form.discountedPrice = this.formatPrice(unit.weekRate, this.discount.percentage)
                },
                reportConversion() {
                    gtag('event', 'conversion', {'send_to': 'AW-972621239/GdjbCNye5X0Qt4vkzwM'});
                    fbq('track', 'Lead', {value: 1, currency: '1',});
                },
                getPreviousQuote(urlParams) {
                    const fromUrl = urlParams.get('previous_quote');

                    if (fromUrl) {
                        return fromUrl;
                    }
                    return Cookies.get('previous_quote');

                },
                findClosestSize(requiredSize) {
                    const availableMovies = [10, 15, 25, 35, 50, 60, 65, 75, 90, 110, 120, 140, 150, 160, 165, 190, 205, 215, 235, 250, 270, 290, 475];
                    if (availableMovies.includes(requiredSize))
                        return requiredSize;

                    let delta = 999;
                    let closest = availableMovies[0];

                    availableMovies.forEach((e) => {
                        let pdelta = requiredSize - e;
                        if (pdelta < 0)
                            pdelta *= -1;
                        if (pdelta < delta) {
                            delta = pdelta;
                            closest = e;
                        }

                    });
                    return closest;
                },
                getVideo(size) {
                    return `/video/${this.findClosestSize(size)}_sqft.mp4`;
                },
                handleSlideChange(data) {
                    const index = data?.currentSlideIndex ?? 1;

                    this.form.unitIndex = index;
                    this.swapUnit(index);
                },
                nextSlide() {
                    if (this.$refs.carousel) {
                        this.$refs.carousel.next();
                    }
                },
                prevSlide() {
                    if (this.$refs.carousel) {
                        this.$refs.carousel.prev();
                    }
                },
                handleSlideClick(index) {
                    if (this.$refs.carousel) {
                        this.$refs.carousel.slideTo(index, true);
                        this.$refs.carousel.data.currentSlide = index;

                        nextTick(() => {
                            console.log(this.$refs.carousel.data);
                        })
                    }
                },
                async showPriceComparison() {
                    try {
                        const response = await axios.get(`/storefirst/api/v1/comparison-html?site-id=${this.form.selectedLocation.SiteID}`);

                        this.comparisonHtml = response.data;

                        nextTick(() => {
                            comparisonPriceTable().then(() => {
                                this.showComparisonTable = true;
                            })
                        })
                    } catch (err) {
                        this.$snotify.error(
                            'Sorry we appear to be having issues. Please try again or contact support for assistance',
                            'Error'
                        );
                    }
                }
            },
            watch: {
                'form.selectedLocation': function (site, prev) {
                    const params = this.getCsrfAwareParams({'id': site.SiteID});
                    const discountPromise = axios.post('/actions/storefirst/quote/site-discounts', params);
                    const sizesPromise = axios.post('/actions/storefirst/quote/site-sizes', params);
                    const detailsPromise = axios.post('/actions/storefirst/quote/site-details', params);

                    this.updateStepState(['2'], 'loading');

                    axios.all([sizesPromise, discountPromise, detailsPromise])
                        .then(axios.spread((units, discounts, details) => {
                            this.handleUnitSizesResponse(units);
                            this.handleDiscountResponse(discounts);
                            this.form.selectedLocation.tel = details.data.tel;
                            this.form.selectedLocation.leadTime = details.data.leadTime;
                            this.form.selectedLocation.limitedUnits = details.data.limitedUnits;

                            this.updateStepState(['2'], 'ready');

                            if (this.skippingStep1) {
                                this.updateStepState([1], 'complete');
                                this.gotoStep(2);
                                this.skippingStep1 = false;
                            }
                        }))
                        .catch((error) => {
                            this.$snotify.error(
                                'Unable to reach with the server. Please refresh the page to try again. If the problem persists, please contact support',
                                'Error'
                            );
                        });
                },
                'form.unitIndex': function (value) {
                    this.swapUnit(value);
                },
                'selectedUnit': function () {
                    this.form.selectedFloor = this.getSelectedFloor()
                    const limited = this.form.selectedFloor.limitedAvailability;
                    this.form.reserveOrEmail = limited ? 'Email' : 'Reserve';
                },
                'moveIn.date': function (val) {
                    this.form.moveInDate = DateFormatter(val);
                }
            },
            computed: {
                spaceType() {
                    const sel = this.selectedUnit;
                    if (sel && sel.locker === true) {
                        return 'Locker';
                    }
                    return 'Unit';
                },
                fullPriceUf() {
                    const {weekRate} = this.selectedUnit.uf[0];
                    return this.formatPrice(weekRate);
                },
                discountPriceUf() {
                    if (!this.selectedUnit || !this.selectedUnit.uf || !this.selectedUnit.uf[0]) {
                        console.warn('selectedUnit or uf or uf[0] is undefined:', this.selectedUnit);
                        return null;
                    }
                    const {weekRate} = this.selectedUnit.uf[0];
                    const discount = this.discount.percentage;
                    return this.formatPrice(weekRate, discount);
                },
                fullPriceEx() {
                    const {weekRate} = this.selectedUnit.ex[0];
                    return this.formatPrice(weekRate);
                },
                discountPriceEx() {
                    if (!this.selectedUnit || !this.selectedUnit.ex || !this.selectedUnit.ex[0]) {
                        console.warn('selectedUnit or ex or ex[0] is undefined:', this.selectedUnit);
                        return null;
                    }
                    const {weekRate} = this.selectedUnit.ex[0];
                    const discount = this.discount.percentage;
                    return this.formatPrice(weekRate, discount);
                },
                fullPriceGf() {
                    const {weekRate} = this.selectedUnit.gf[0];
                    return this.formatPrice(weekRate);
                },
                discountPriceGf() {
                    if (!this.selectedUnit || !this.selectedUnit.gf || !this.selectedUnit.gf[0]) {
                        console.warn('selectedUnit or gf or gf[0] is undefined:', this.selectedUnit);
                        return null;
                    }
                    const {weekRate} = this.selectedUnit.gf[0];
                    const discount = this.discount.percentage;
                    return this.formatPrice(weekRate, discount);
                },
                disabledDates() {
                    const disabledDates = {to: new Date(Date.now())}
                    const location = this.form.selectedLocation;

                    if (location && location.leadTime) {
                        disabledDates.from = new Date(Date.now());
                        disabledDates.from.setDate(disabledDates.from.getDate() + location.leadTime);
                    }

                    return disabledDates;
                }
            }
        });

        app.use(Snotify, {
            toast: {
                position: 'centerTop'
            }
        });

        app.mount(el);
    }
};

export default priceCalculator;
